<template>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <h4>出單紙模板設定</h4>
          <div class="row">
            <div class="col-sm-8">
              <el-input
                placeholder="Please input template ID"
                type="number"
                v-model="templateId"
                @keyup.enter.native="getTemplateSetting(templateId)"
              >
                <el-button
                  ref="template-search"
                  slot="append"
                  icon="el-icon-search"
                  @click.native="getTemplateSetting(templateId)"
                ></el-button>
              </el-input>

              <p>Updated time: {{ displayPrinterTemplateUpdateAt }}</p>
            </div>
            <div class="col-sm-4">
              <el-button @click.native="createPrinterTemplate"
                >新增模板</el-button
              >
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8">
              <h4>master</h4>
              <BoxTextarea
                :textInput="printerTemplateData.master"
                @input="printerTemplateData.master = $event"
                @on-textarea-enter="onUpdateTextArea($event)"
                @on-textarea-edit="onEditTextArea($event)"
                >{{ displayPrinterTemplateStatusOfUpdated }}</BoxTextarea
              >
            </div>
            <div class="col-sm-4">
              <p></p>
              <h4>options</h4>
              <BoxTextarea
                :textInput="printerTemplateData.options"
                @input="printerTemplateData.options = $event"
                @on-textarea-enter="onUpdateTextArea($event)"
                @on-textarea-edit="onEditTextArea($event)"
                >{{ displayPrinterTemplateStatusOfUpdated }}</BoxTextarea
              >
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
</template>


<script>
import {
  getPrinterTemplateById
} from "src/javascripts/generalPages/fetchData";

import {
  createPrinterTemplate
} from "src/javascripts/generalPages/postData";
import {
  updatePrinterTemplateById
} from "src/javascripts/generalPages/updateData";

import BoxTextarea from "./BoxTextarea.vue";
import moment from "moment-timezone";

export default {
  components: {
    BoxTextarea
  },
  data() {
    return {
      templateId: null,
      printerTemplateData: {
        update_at: ""
      },
      printerTemplateStatusOfUpdated: false
    };
  },
  computed: {
    displayPrinterTemplateStatusOfUpdated: function() {
      return this.printerTemplateStatusOfUpdated ? "已更新" : "";
    },
    displayPrinterTemplateUpdateAt: function() {
      return this.printerTemplateData["updated_at"]
        ? moment(this.printerTemplateData["updated_at"])
            .tz("Asia/Taipei")
            .format("YYYY-MM-DD HH:mm:ss")
        : "";
    }
  },
  methods: {
    createPrinterTemplate() {
      console.log("createPrinterTemplate: ");
      let createPrinterTemplateData = {
        master: "<CB>快一點預設模板</CB><BR>",
        options: `{
"scheduleAt": ":scheduleAt<BR>",
"itemsTemplate" : "<L>:qty x :name </L><BR><RIGHT><BOLD>:optionsTemplate</BOLD></RIGHT>\n"
}`
      };
      let that = this;
      createPrinterTemplate(createPrinterTemplateData)
        .then(createPrinterTemplateRes => {
          console.log("createPrinterTemplateRes: ", createPrinterTemplateRes);
          let id = createPrinterTemplateRes.data.id;
          that.templateId = id;
          that.getTemplateSetting(id);
        })
        .catch(createPrinterTemplateErr => {
          console.log("createPrinterTemplateErr: ", createPrinterTemplateErr);
        });
    },
    getTemplateSetting(id) {
      console.log(id);
      this.printerTemplateStatusOfUpdated = false;
      let that = this;
      getPrinterTemplateById(id)
        .then(getPrinterTemplateByIdRes => {
          console.log("getPrinterTemplateByIdRes: ", getPrinterTemplateByIdRes);
          that.printerTemplateData = Object.assign(
            {},
            getPrinterTemplateByIdRes.data
          );
          that.printerTemplateMasterObj = Object.assign(
            {},
            {
              text: getPrinterTemplateByIdRes.data.master,
              update: false
            }
          );
          console.log(
            "that.printerTemplateMasterObj: ",
            that.printerTemplateMasterObj
          );
          that.printerTemplateOptionObj = Object.assign(
            {},
            {
              text: getPrinterTemplateByIdRes.data.options,
              update: false
            }
          );
        })
        .catch(getPrinterTemplateByIdErr => {
          console.log("getPrinterTemplateByIdErr: ", getPrinterTemplateByIdErr);
        });
    },
    onEditTextArea(e) {
      this.printerTemplateStatusOfUpdated = false;
      console.log("onEditTextArea: ", e);
    },
    onUpdateTextArea(e) {
      console.log("updateTextArea: ", e);
      // call update
      this.printerTemplateStatusOfUpdated = true;
      updatePrinterTemplateById(
        this.printerTemplateData.id,
        this.printerTemplateData
      )
        .then(updatePrinterTemplateByIdRes => {
          console.log(
            "updatePrinterTemplateByIdRes: ",
            updatePrinterTemplateByIdRes
          );
        })
        .catch(updatePrinterTemplateByIdErr => {
          console.log(
            "updatePrinterTemplateByIdErr: ",
            updatePrinterTemplateByIdErr
          );
        });
    }
  }
};
</script>

<style>
.layout-style1 {
  color: rgb(0, 60, 255);
}
.layout-style2 {
  color: rgb(255, 102, 0);
}
.off {
  color: red;
}
.on {
  color: rgb(0, 255, 0);
}

.all-icons .font-icon-detail p {
  color: rgb(0, 0, 0);
  font-weight: bold;
  font-family: fantasy;
}
.top-position-132 {
  top: 132px;
}
.text-red {
  color: red;
}
</style>
